import { render } from "./App.vue?vue&type=template&id=0655d97e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0655d97e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\winni\\Desktop\\網頁設計\\作品\\怪獸遊戲\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0655d97e"]])

export default __exports__